/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const EnergyCostSavingsService = require('./energyCostSavings/energyCostSavingsService');
const StoreLocatorService = require('./storeLocator/storeLocatorService');

const imageGalleryDirective = require('./imageGallery/imageGalleryDirective');
const productFeaturesDirective = require('./productFeatures/productFeaturesDirective');
const productDetailDirective = require('./productDetail/productDetailDirective');
const energyScoreDirective = require('./energyScore/energyScoreDirective');
const ecoViewDirective = require('./ecoView/ecoViewDirective');
const energyCostSavingsDirective = require('./energyCostSavings/energyCostSavingsDirective');
const productCertificationsDirective = require('./productCertifications/productCertificationsDirective');
const priceChartDirective = require('./priceChart/priceChartDirective');
const priceRankingDirective = require('./priceRanking/priceRankingDirective');
const onlineOffersDirective = require('./onlineOffers/onlineOffersDirective');
const storeLocatorDirective = require('./storeLocator/storeLocatorDirective');
const ratingsDirective = require('./ratings/ratingsDirective');
const productReviewsDirective = require('./productReviews/productReviewsDirective');

const productSectionDirective = require('./productSection/productSectionDirective');

const productSectionsModule = angular
    .module('enervee_utils.product_sections', [])
    .factory('EnergyCostSavingsService', EnergyCostSavingsService)
    .factory('StoreLocatorService', StoreLocatorService)
    .directive('ratings', ratingsDirective)
    .directive('imageGallery', imageGalleryDirective)
    .directive('productFeatures', productFeaturesDirective)
    .directive('productDetail', productDetailDirective)
    .directive('energyScore', energyScoreDirective)
    .directive('ecoView', ecoViewDirective)
    .directive('energyCostSavings', energyCostSavingsDirective)
    .directive('productCertifications', productCertificationsDirective)
    .directive('priceChart', priceChartDirective)
    .directive('priceRanking', priceRankingDirective)
    .directive('onlineOffers', onlineOffersDirective)
    .directive('storeLocator', storeLocatorDirective)
    .directive('productReviews', productReviewsDirective)
    .directive('productSection', productSectionDirective);

module.exports = productSectionsModule;
